export default __webpack_public_path__ + "static/media/img-600x400-6.9c5ae3e8.jpg";